 
import { Card, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useDomain from '@/hooks/useDomain';

const EcomStatItem = ({ stat }) => {
  return (
    <Col xs={6} md={4} className={stat.className}>
      <h6 className="pb-1 text-700">{stat.title}</h6>

      <Link to={stat.link}>
        <p className="font-sans-serif lh-1 mb-1 fs-3">{stat.amount}</p>
      </Link>

      <div className="d-flex align-items-center">
        {stat.subAmount && (
          <>
            <h6 className="fs-10 text-500 mb-0">{stat.subAmount}</h6>
            <h6
              className={classNames('fs-11 ps-3 mb-0', {
                'text-success': stat.type === 'up',
                'text-danger': stat.type === 'down',
                'text-primary': stat.type === 'standard',
                'text-warning': stat.type === 'warning',
                'text-info': stat.type === 'pending'
              })}
            >
              <FontAwesomeIcon icon="caret-up" className="me-1" />
              {stat.percent}%
            </h6>
          </>
        )}
      </div>
    </Col>
  );
};

const EcomStat = ({ data }) => {
  const { domain, domain_slug } = useDomain();

  data = [
    {
      title: 'ورود به صفحه اول 😍',
      amount: '15,450',
      subAmount: null,
      type: 'standard',
      percent: 21.8,
      className: 'border-200 border-bottom border-end pb-4',
      link: `/keyword-tracker/keywords/${domain_slug}/${domain}?FByRank=%5Band%2Clessthanorequals%2C10%5D&FByPreviousRank=%5Band%2Cgreaterthan%2C10%5D`
    },
    {
      title: 'خروج از صفحه اول 😢',
      amount: '1,054',
      subAmount: null,
      type: 'warning',
      percent: 21.8,
      className:
        'border-200 border-md-200 border-bottom border-md-end pb-4 ps-3',
      link: `/keyword-tracker/keywords/${domain_slug}/${domain}?FByRank=%5Band%2Cgreaterthan%2C10%5D&FByPreviousRank=%5Band%2Clessthanorequals%2C10%5D`
    },
    {
      title: 'بدون رتبه 😐',
      amount: '145',
      subAmount: null,
      type: 'up',
      percent: 21.8,
      className:
        'border-200 border-bottom border-end border-md-end-0 pb-4 pt-4 pt-md-0 ps-md-3',
      link: `/keyword-tracker/keywords/${domain_slug}/${domain}?FByRank=%5Band%2Cequals%2C999%5D`
    },

    {
      title: 'ورود به نتایج 😊',
      amount: '15,450',
      subAmount: null,
      type: 'standard',
      percent: 21.8,
      className: 'border-200 border-bottom border-end pt-4 pb-4',
      link: `/keyword-tracker/keywords/${domain_slug}/${domain}?FByRank=%5Band%2Clessthanorequals%2C100%5D&FByPreviousRank=%5Band%2Cequals%2C999%5D`
    },
    {
      title: 'خروج از نتایج 😔',
      amount: '1,054',
      subAmount: null,
      type: 'warning',
      percent: 21.8,
      className:
        'border-200 border-md-200 border-bottom border-md-end pt-4 pb-4 ps-3',
      link: `/keyword-tracker/keywords/${domain_slug}/${domain}?FByRank=%5Band%2Cequals%2C999%5D&FByPreviousRank=%5Band%2Clessthanorequals%2C100%5D`
    },
    {
      title: 'در حال افت',
      amount: '145',
      subAmount: null,
      type: 'up',
      percent: 21.8,
      className: 'border-200 border-md-200 border-bottom pt-4 pb-4 ps-3',
      link: `/keyword-tracker/keywords/${domain_slug}/${domain}?FByRank=%5Band%2Cequals%2C999%5D`
    },
    {
      title: 'در حال رشد',
      amount: '100',
      subAmount: null,
      type: 'down',
      percent: 21.8,
      className:
        'border-200 border-md-200 border-bottom border-md-bottom-0 border-md-end pt-4 pb-md-0 ps-3 ps-md-0',
      link: `/keyword-tracker/keywords/${domain_slug}/${domain}?FByRank=%5Band%2Cequals%2C999%5D`
    },
    {
      title: 'مغایرت با صفحه هدف',
      amount: '365',
      subAmount: null,
      type: 'up',
      percent: 21.8,
      className:
        'border-200 border-md-bottom-0 border-end pt-4 pb-md-0 ps-md-3',
      link: `/keyword-tracker/keywords/${domain_slug}/${domain}?FByHaveConflictWithLandingUrl=%5Band%2Cequals%2Ctrue%5D`
    },
    {
      title: 'هم نوع خواری 👹',
      amount: '861',
      subAmount: null,
      type: 'pending',
      percent: 21.8,
      className: 'pb-0 pt-4 ps-3',
      link: `/keyword-tracker/keywords/${domain_slug}/${domain}?FByHaveCannibal=%5Band%2Cequals%2Ctrue%5D`
    }
  ];

  return (
    <Card className="py-3 mb-3">
      <Card.Body className="py-3">
        <Row className="g-0">
          {data.map((stat, index) => (
            <EcomStatItem
              key={stat.title}
              stat={stat}
              index={index}
              lastIndex={data.length - 1}
            />
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default EcomStat;
